import { Box, Flex, Spinner } from "@chakra-ui/react";
import { useAppSelector } from "../../app/hooks";
import { selectMobileActiveScreen } from "../../app/slice/mobileSlice";
import { selectAppState } from "../../app/slice/appSlice";
import MobileLocationsScreen from "./MobileLocationsScreen";
import MobileConditionsScreen from "./MobileConditionsScreen";
import MobileSlotsScreen from "./MobileSlotsScreen";
import MobileBottomSheet from "./MobileBottomSheet";
import { APP_PLATFORM } from "../../config";
import ReviewStickyWidgetV2 from "../ReviewCollector/ReviewStickyWidgetV2";
import { Platform } from "../../models";

const MobileFlowBuilder = () => {
  const activeScreen = useAppSelector(selectMobileActiveScreen);
  const { loading } = useAppSelector((state) => state.mobile);
  const { loading: appLoading } = useAppSelector(selectAppState);
  const renderScreen = () => {
    switch (activeScreen) {
      case "locations":
        return <MobileLocationsScreen />;
      case "conditions":
        return <MobileConditionsScreen />;
      case "slots":
        return <MobileSlotsScreen />;
      default:
        return null;
    }
  };

  return (
    <Box h="100%" w="100%" flex={1}>
      {loading || !activeScreen ? <Flex
        justifyContent={"center"} alignItems={"center"} h="100vh" w="100%">
        <Spinner variant={"ring"} size={"sm"} />
      </Flex> :
        renderScreen()}
      <MobileBottomSheet />
      {APP_PLATFORM === Platform.Shopify && !appLoading && <ReviewStickyWidgetV2 />}
    </Box>
  );
};

export default MobileFlowBuilder;
